"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ToolBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _ToolBarItems = require("./ToolBarItems");
var _DropdownButton = _interopRequireDefault(require("./../Dropdown/DropdownButton"));
var _Dropdown = _interopRequireDefault(require("./../Dropdown/Dropdown"));
var _jsxRuntime = require("react/jsx-runtime");
const ToolBar = ({
  config,
  data,
  labels
}) => {
  const {
    items,
    defaultSelection,
    dropdown,
    links
  } = config;
  const partition = (allItems = []) => {
    const itemsLeft = [];
    const itemsRight = [];
    allItems.forEach(item => item.align === 'right' ? itemsRight.push(item) : itemsLeft.push(item));
    return [itemsLeft, itemsRight];
  };
  const [itemsLeft, itemsRight] = partition(items);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-e-tool-bar",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-tool-bar__left",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolBarItems.ToolBarItems, {
        items: itemsLeft,
        defaultSelection: defaultSelection
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-tool-bar__center"
    }), dropdown != null && dropdown.showDropdown ? (links == null ? void 0 : links.length) > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `ccl-e-tool-bar__right ${(dropdown == null ? void 0 : dropdown.visible) === 'sm' ? 'd-md-none' : 'd-none d-md-flex'}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownButton.default, {
          align: "end",
          title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            type: "menu"
          }),
          id: "dropdown-menu-align-end",
          children: links == null ? void 0 : links.map((link, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.default.Item, {
            eventKey: index + 1,
            href: link.linkTo,
            className: "ccl__text ccl__text--interactive-text",
            children: link.text
          }, index + 1))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `ccl-e-tool-bar__right ${(dropdown == null ? void 0 : dropdown.visible) === 'sm' ? 'd-none d-md-flex' : 'd-md-none'}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolBarItems.ToolBarItems, {
          items: links,
          defaultSelection: defaultSelection
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-tool-bar__right",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolBarItems.ToolBarItems, {
        items: links,
        defaultSelection: defaultSelection
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-tool-bar__right",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolBarItems.ToolBarItems, {
        items: itemsRight,
        defaultSelection: defaultSelection
      })
    })]
  });
};
exports.ToolBar = ToolBar;
ToolBar.defaultProps = {
  config: {
    items: []
  }
};